              var timeline_swiper = new Swiper('.timeline-slider', {
                autoHeight: true,
                effect: 'fade',
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                speed: 500,
                direction: 'horizontal',
                loop: false,
                effect: 'fade',
                spaceBetween: 30,
                on: {
                  init: function () {
                    $('.swiper-pagination-custom .swiper-pagination-switch').removeClass('active');
                    $('.swiper-pagination-custom .swiper-pagination-switch').eq(0).addClass('active');
                  },
                  slideChangeTransitionStart: function () {
                    $('.swiper-pagination-custom .swiper-pagination-switch').removeClass('active');
                    $('.swiper-pagination-custom .swiper-pagination-switch')
                      .eq(timeline_swiper.realIndex)
                      .addClass('active');
                  },
                },
              });
    
              var textSwiper = new Swiper('.textSwiper', {
                autoHeight: true,
                effect: 'fade',
                autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                },
                speed: 500,
                direction: 'horizontal',
                loop: false,
                effect: 'slide',
                spaceBetween: 30,
                on: {
                  init: function () {
                    $('.swiper-pagination-custom .swiper-pagination-switch').removeClass('active');
                    $('.swiper-pagination-custom .swiper-pagination-switch').eq(0).addClass('active');
                  },
                  slideChangeTransitionStart: function () {
                    $('.swiper-pagination-custom .swiper-pagination-switch').removeClass('active');
                    $('.swiper-pagination-custom .swiper-pagination-switch').eq(textSwiper.realIndex).addClass('active');
                  },
                },
              });
    
              $('.swiper-pagination-custom .swiper-pagination-switch').click(function () {
                timeline_swiper.slideTo($(this).index());
                textSwiper.slideTo($(this).index());
                $('.swiper-pagination-custom .swiper-pagination-switch').removeClass('active');
                $(this).addClass('active');
              });